import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess({ packing_house_id, packing_house_process_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/new_inspect/packing_house_process/${packing_house_id}/${packing_house_process_id}`
    );
  },
  fetchHarvestedBatch({ packing_house_id, packing_house_process_id, harvested_batch_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/new_inspect/harvested_batch/${packing_house_id}/${packing_house_process_id}/${harvested_batch_id}`
    );
  },
  fetchExportedBatches({ container_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/new_inspect/container/${container_id}/exported_batches`
    );
  },
  fetchTemplate({ packing_house_id, packing_house_process_id,  harvested_batch_id, packing_process_quality_template_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/new_inspect/harvested_batch/${packing_house_id}/${packing_house_process_id}/${harvested_batch_id}/quality_template/${packing_process_quality_template_id}`
    );
  },
  createWithSamplings({
    packing_house_id,
    packing_house_process_id,
    harvested_batch_id,
    packing_process_quality_template_id,
    started_at,
    finished_at,
    samplings,
    quality_samplings,
  }) {
    return RequesterV1.post(
      `/packing_house/quality_control/process/new_inspect/harvested_batch/${packing_house_id}/${packing_house_process_id}/${harvested_batch_id}/quality_template/${packing_process_quality_template_id}/create`,
      {
        quality_inspect: {
          started_at,
          finished_at,
          samplings,
        },
        quality_samplings
      }
    );
  },
  createWithoutSamplings({
    packing_house_id,
    packing_house_process_id,
    harvested_batch_id,
    packing_process_quality_template_id,
    started_at,
    finished_at,
    samplings,
    quality_generals,
  }) {
    return RequesterV1.post(
      `/packing_house/quality_control/process/new_inspect/harvested_batch/${packing_house_id}/${packing_house_process_id}/${harvested_batch_id}/quality_template/${packing_process_quality_template_id}/create_without_samplings`,
      {
        quality_inspect: {
          started_at,
          finished_at,
          samplings,
        },
        quality_generals
      }
    );
  },
};
